module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "view",
    class: {
      'app-view': !_vm.custom
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_vm._v("Copyright© 2022 福音影视网.Madrid, Spain")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15d94212","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/components/AppView.vue
// module id = 308
// module chunks = 0